  // CART TIMER
  document.addEventListener("DOMContentLoaded", function () {
    const time_in_minutes = 10;
    const current_time = Date.parse(new Date());
    const countdownDate = new Date(current_time + time_in_minutes*60*1000);
  
    function updateCountdown() {
      
      const now = new Date().getTime();
      const timeLeft = countdownDate - now;
  
      if (timeLeft < 0) {
        displayZeroTime();
        return;
      }
  
      const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
  
      seconds = seconds < 10 ? "0" + seconds : seconds;

      if (document.getElementById("minutes")) {
        document.getElementById("minutes").textContent = minutes;
        document.getElementById("seconds").textContent = seconds;
      }
  
      
    }
  
    function displayZeroTime() {
      if (document.getElementById("minutes")) {
        document.getElementById("minutes").textContent = 0;
        document.getElementById("seconds").textContent = "00";
      }
      
    }
  
    updateCountdown();
    setInterval(updateCountdown, 1000);
  
    setTimeout(displayZeroTime, time_in_minutes * 60 * 1000);
  });